import React, { useState } from 'react';

const CustomSelect = ({ children, options, onSelect, className = '' }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`${className} relative w-fit flex-1 hover:cursor-pointer`}
      onClick={() => setOpen(!open)}
    >
      {children}

      {open && (
        <div className="absolute z-50 w-full rounded-lg bg-white p-3 shadow-md">
          <ul className="flex flex-col gap-2">
            {options?.map((option) => (
              <li
                key={option.value}
                className="flex cursor-pointer flex-col gap-2 rounded-[4px] p-1.5 text-sm font-normal capitalize text-gray-900 transition-all hover:bg-gray-100"
                onClick={() => onSelect?.(option.value)}
              >
                <p className="fredoka flex text-xl font-medium text-[#012E33]">{option.value}</p>
                <p className="fredoka flex text-lg font-medium text-[#678285]">{option?.label}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
